import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import {
  Filter,
  FilterClearBtn,
  FilterLabel,
  FilterOptionsList,
  FilterPlaceholder,
  FilterTrigger,
  FilterValue,
} from '@src/design-system/filter';
import { MembersList } from '@src/shared/components/members-list';

import type { TTempFilters } from './';
import type { TMember } from '@src/shared/types/member';

export function ReminderCreatedByFilter({
  tempFilters,
  setTempFilters,
}: {
  tempFilters: TTempFilters;
  setTempFilters: (filters: TTempFilters) => void;
}) {
  return (
    <Filter
      multiple={false}
      value={tempFilters?.created_by}
      onValueChange={(value) => {
        setTempFilters({
          ...tempFilters,
          created_by: value,
        });
      }}
    >
      <div className='w-full flex items-center justify-between'>
        <FilterLabel>Created By</FilterLabel>
        <FilterClearBtn />
      </div>
      <FilterTrigger>
        <FilterPlaceholder>Created by</FilterPlaceholder>
        <FilterValue className='flex items-center'>
          {(value: TMember) => {
            return (
              <Avatar className='size-7 -mr-1 border-2 border-white'>
                <AvatarImage
                  src={value?.user?.avatar || ''}
                  alt={value?.user?.first_name || ''}
                />
                <AvatarFallback colorId={value?.user?.id || 0}>
                  {value?.user?.first_name?.[0]}
                </AvatarFallback>
              </Avatar>
            );
          }}
        </FilterValue>
      </FilterTrigger>
      <FilterOptionsList>
        {({ value, setValue, multiple }) => {
          if (multiple) return null;

          return (
            <MembersList
              isItemSelected={(member) => {
                return String((value as TMember).id) === String(member.id);
              }}
              onClickItem={(member) => {
                setValue(member);
              }}
            />
          );
        }}
      </FilterOptionsList>
    </Filter>
  );
}
